import * as types from './mutation-types'
import Vue from 'vue'
import { IMesureTypeState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbMesureType, IAloDbMesureTypeConstParam } from '@/models/alodb/AloDbMesureType';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IMesureTypeState> = {
     
    //Gestion des recherches de missions
    [types.MESURETYPE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.MesureType.Title').toString()}).toString()
        state.mesureTypeLoading = true
    },
    [types.MESURETYPE_SUCCESS]: (state, mesureTypes:Array<AloDbMesureType>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.MesureType.Title').toString()}).toString()
        state.mesureTypes = mesureTypes   
        state.mesureTypeLoading = false             
    },
    [types.MESURETYPE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MesureType.Title').toString()}).toString()
        state.mesureTypes = []
        state.mesureTypeLoading = false
    },
    [types.MESURETYPE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.MesureType.Title').toString()} ${itemId}`}).toString()
        state.mesureTypeLoading = true
    },
    [types.MESURETYPE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MesureType.Title').toString()}).toString()
        state.mesureTypeLoading = false
    },
    [types.MESURETYPE_SELECT_DETAIL_SUCCESS]: (state,mesureType:AloDbMesureType) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.MesureType.Title').toString()} ${mesureType.MET_ID}`}).toString()        
        //1, on met à jour de m'mesureType dans la liste des mesureTypes
        const index = state.mesureTypes.findIndex(m => m.MET_ID == mesureType.MET_ID)
        state.mesureTypes.splice(index == -1 ? state.mesureTypes.length : index, index == -1 ? 0 : 1, mesureType)
        state.mesureTypeLoading = false
    },
    [types.MESURETYPE_SELECT_DETAIL]: (state,mesureType:AloDbMesureType) => {                
        state.originalAdmMesureType = mesureType        
        state.modifiedAdmMesureType = new AloDbMesureType({...mesureType,MET_DATADD:mesureType.MET_DATADD?mesureType.MET_DATADD.toUTCString():null,MET_DATDEL:mesureType.MET_DATDEL?mesureType.MET_DATDEL.toUTCString():null} as IAloDbMesureTypeConstParam )
    },
    [types.MESURETYPE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.MesureType.Title').toString()} ${libelle}`}).toString()
        state.mesureTypeLoading = true
    },
    [types.MESURETYPE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.MesureType.Title').toString()}).toString()
        state.mesureTypeLoading = false
    },
    [types.MESURETYPE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmMesureType = {...state.modifiedAdmMesureType,...newProperties}
    },
    [types.MESURETYPE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    }           
}


export default mutations
